import { useEffect } from 'react';
import useAuth from '../hooks/useAuth'; // Verifique o caminho para o seu hook

const LogoutPage = () => {
  const { logout } = useAuth();

  useEffect(() => {
    // A função logout do seu useAuth já deve limpar o token e redirecionar para /login
    logout();
  }, [logout]);

  return <div>A terminar a sessão...</div>;
};

export default LogoutPage;